import { get } from 'lodash';
import { getOfficePhoneLinesSummaryDetails } from './getOfficePhoneLinesSummaryDetails';

/**
 * Calculate total for a single phone line
 * @param {Array} rows - Array of row objects with pricing
 * @returns {Object} Total object with all charge types
 */
const calculateLineTotal = (rows) => {
  const total = {
    monthlyCharges: 0,
    oneTimeCharges: 0,
    fiveYearEasyPaymentCharges: 0,
    threeYearEasyPaymentCharges: 0
  };

  rows.forEach(row => {
    total.monthlyCharges += get(row, 'monthlyCharges', 0);
    total.oneTimeCharges += get(row, 'oneTimeCharges', 0);
    total.fiveYearEasyPaymentCharges += get(row, 'fiveYearEasyPaymentCharges', 0);
    total.threeYearEasyPaymentCharges += get(row, 'threeYearEasyPaymentCharges', 0);
  });

  return total;
};

/**
 * Get Office Phone Lines price selections for summary
 * @param {Array} formFields - Form fields from Contentful
 * @param {Array} officePhoneLinesData - Array of office phone line data
 * @returns {Array} Array of price selection objects
 */
export const getOfficePhoneLinesPriceSelections = (formFields, officePhoneLinesData) => {
  if (!officePhoneLinesData || !Array.isArray(officePhoneLinesData) || officePhoneLinesData.length === 0) {
    return [];
  }

  const priceSelections = [];

  officePhoneLinesData.forEach((lineData, index) => {
    const lineNumber = index + 1;
    const sectionTitle = lineNumber === 1 ? 'Office Phone' : `Office Phone ${lineNumber}`;
    
    const summaryDetails = getOfficePhoneLinesSummaryDetails(lineData);
    
    if (summaryDetails && summaryDetails.length > 0) {
      priceSelections.push({
        rows: summaryDetails,
        total: calculateLineTotal(summaryDetails),
        sectionTitle
      });
    }
  });

  return priceSelections;
};

/**
 * Get Office Phone Lines totals for vulcanPricing
 * @param {Array} officePhoneLinesData - Array of office phone line data
 * @returns {Object} Totals object with monthly, oneTime, threeYearEasyPayment, fiveYearEasyPayment
 */
export const getOfficePhoneLinesTotals = (officePhoneLinesData) => {
  if (!officePhoneLinesData || !Array.isArray(officePhoneLinesData) || officePhoneLinesData.length === 0) {
    return {
      monthly: 0,
      oneTime: 0,
      threeYearEasyPayment: 0,
      fiveYearEasyPayment: 0
    };
  }

  const totals = {
    monthly: 0,
    oneTime: 0,
    threeYearEasyPayment: 0,
    fiveYearEasyPayment: 0
  };

  officePhoneLinesData.forEach(lineData => {
    const summaryDetails = getOfficePhoneLinesSummaryDetails(lineData);
    const lineTotal = calculateLineTotal(summaryDetails);
    
    totals.monthly += get(lineTotal, 'monthlyCharges', 0);
    totals.oneTime += get(lineTotal, 'oneTimeCharges', 0);
    totals.threeYearEasyPayment += get(lineTotal, 'threeYearEasyPaymentCharges', 0);
    totals.fiveYearEasyPayment += get(lineTotal, 'fiveYearEasyPaymentCharges', 0);
  });

  return totals;
};

/**
 * Get Office Phone Lines form data for payload
 * @param {Array} officePhoneLinesData - Array of office phone line data
 * @returns {Object} Form data object
 */
export const getOfficePhoneLinesFormData = (officePhoneLinesData) => {
  return {
    officePhoneLinesData: officePhoneLinesData || []
  };
};

